import * as XLSX from "xlsx";

const exportToExcel = (tableData, fileName) => {

  if (!tableData || tableData.length === 0) {
    alert("No data available to export.");
    return;
  }

  const MAX_COLUMN_WIDTH = 30;
  // Create a worksheet from the table data
  // console.log("data before sort",tableData)
  const sortedData = [...tableData].sort((a, b) => b["Sales ID"] - a["Sales ID"]);
  // console.log("sortedData1",sortedData)

  const worksheet = XLSX.utils.json_to_sheet(sortedData);

  // Calculate column widths dynamically based on content
  const columnWidths = Object.keys(tableData[0]).map((key) => {
    const maxLength = Math.max(
      key.length, // Header length
      ...tableData.map(row => row[key] ? row[key].toString().length : 10) // Data length
    );

    return { wch: Math.min(maxLength + 2, MAX_COLUMN_WIDTH) }; // Apply max width cap
  });

  worksheet["!cols"] = columnWidths;

   // Apply styling to the headers
   const headerKeys = Object.keys(tableData[0]); // Get header keys
   headerKeys.forEach((key, colIndex) => {
     const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIndex }); // Encode header cell position
     if (!worksheet[cellAddress]) return; // Skip if the cell doesn't exist
 
     worksheet[cellAddress].s = {
       fill: { fgColor: { rgb: "FFFF00" } }, // Yellow background
       font: { bold: true, color: { rgb: "000000" } }, // Bold black text
       alignment: { horizontal: "center" } // Center align text
     };
   });

  // Create a workbook and add the worksheet
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  // Export the workbook to a file
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export {exportToExcel};
